import { FC } from 'react'

import './style.scss'
import CONFIG from '../../../config'
import { AuthRoles } from '../../models'
import { HeaderPublic, Header, Footer } from '../'
import { GotoTop, Title, TextSummary, AlertBrowser } from '../../components/UI'
import { Background } from '../../components'

type LayoutHomeProps = {
  role?: AuthRoles
}

const LayoutHome:FC<LayoutHomeProps> = ({ children, role = '' })  => {
  return (
    <>
      {role === CONFIG.AUTH.ROLES.ADMIN ? <Header type="public" role={role} />: <HeaderPublic />}

      <main className="main">
        <div className="container-fluid">
          <div className="row align-items-stretch h-full">
            <Background role={role} />

            <div className="col-12 lg:col-6 pt-30 pb-70 lg:py-70">
              <div className="home-wrapper">
                <Title color="primary" size="30" weight="bold" align="center" className="lg:fz-40">
                {role === CONFIG.AUTH.ROLES.ADMIN && 'Administrador '} Mi Portal INDISA
                </Title>
                {children}
              </div>

              <TextSummary className="exam_alert home-alert mt-30">
                <div className="row">
                  <div className="alert-col-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10.5" stroke="#0098D8"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z" fill="#0098D8"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11 8C11 7.44772 11.4477 7 12 7H12.01C12.5623 7 13.01 7.44772 13.01 8C13.01 8.55228 12.5623 9 12.01 9H12C11.4477 9 11 8.55228 11 8Z" fill="#0098D8"/></svg></div>
                  <div className="alert-col-text">
                    Si tienes dificultad para registrarte contáctanos por medio de nuestro <a href="https://www.indisa.cl/formulario-de-contacto/?reason=mi-portal-indisa" target="_blank" rel="noreferrer">formulario de contacto</a>.
                  </div>
                </div>
              </TextSummary>
              <AlertBrowser />

            </div>
          </div>
        </div>
      </main>

      <Footer type="public" role={role} />
      <GotoTop />
    </>
  )
}

export { LayoutHome }